import { MakePaths } from "common/router/types";
import { MakeRoutesOpts } from "common/router/utils/routes";
import { makeUrls } from "common/router/utils/urls";

import { makeClientRoutes } from "client/routes/types";

import { SubscriptionSearch } from "../types";

const paths = {
  list: "/",
  detail: "/:id",
};

type SubscriptionParams = {
  id: number;
};

type SubscriptionPathDefinitions = {
  list: {};
  detail: { Params: SubscriptionParams; Search: SubscriptionSearch };
};

export type SubscriptionPaths = MakePaths<SubscriptionPathDefinitions>;

export const useSubscriptionRoutes = (opts: MakeRoutesOpts) => {
  return makeClientRoutes(opts, [
    {
      path: paths.list,
      element: () => import("../components/SubscriptionsPage"),
      pageName: "subscriptions",
    },
    {
      path: paths.detail,
      element: () => import("../components/SubscriptionPage"),
      pageName: "subscription",
    },
  ]);
};

export const makeSubscriptionUrls = (base: string) => {
  return makeUrls<SubscriptionPathDefinitions>(base, {
    list: { path: paths.list },
    detail: { path: paths.detail, to: ({ id }) => `/${id}` },
  });
};
